module.exports = __webpack_public_path__ + "static/img/EH.ae8e44b7.jpg";